// src/components/TextareaAutoSizeWrapper.tsx
import React from "react";
import TextareaAutosize from "react-autosize-textarea";
import type { ChangeEvent } from "react";
import { withSanitizedOnChange } from "@/utils/xmlSanitizerOnChange";

type InputEvent = ChangeEvent<HTMLTextAreaElement>;

export class TextareaAutoSizeWrapper extends React.Component<
TextareaAutosize.Props
> {
  private textarea!: HTMLTextAreaElement;
  private observer!: MutationObserver;
  private _lastValue = "";

  // 1. Your wrapper-specific logic on *user* edits
  private readonly handleUserChange = (e: InputEvent) => {
    this._lastValue = e.target.value; // keep your cache in sync
    if (this.props.onChange) this.props.onChange(e); // call external handler
  };

  componentDidMount() {
    const config = { attributes: true, childList: true, subtree: true };
    const target = this.textarea;
    this._lastValue = target.value;

    const programmaticHandler = withSanitizedOnChange(this.handleUserChange);
    this.observer = new MutationObserver(() => {
      if (this._lastValue !== target.value) {
        const minimalEvt = {
          target,
          currentTarget: target,
          preventDefault: () => {},
          stopPropagation: () => {},
          isDefaultPrevented: () => false,
          isPropagationStopped: () => false,
          nativeEvent: new Event("change", { bubbles: true }),
          persist: () => {}
        } as unknown as InputEvent;

        programmaticHandler(minimalEvt);
        this._lastValue = target.value;
      }
    });

    this.observer.observe(target, config);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  render() {
    // 3. Wrap *only* your composed user‐handler through the sanitizer
    const sanitizedOnChange = withSanitizedOnChange(this.handleUserChange);

    return (
        <TextareaAutosize
            {...(this.props as TextareaAutosize.Props)}
            onChange={sanitizedOnChange}
            ref={el => (this.textarea = el as HTMLTextAreaElement)}
        />
    );
  }
}
